/*
 * -----------------------------------------------------------------------
 *  <copyright file="study-cohorts.ts" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { gql } from '@apollo/client';
import { StudyCohortFragment } from './fragments';

export const GET_STUDY_COHORTS = gql`
    query studyCohorts($studyId: ObjectId!, $timestamp: DateTime) {
        cohorts(studyId: $studyId, timestamp: $timestamp) {
            ...StudyCohortFields
        }
    }
    ${StudyCohortFragment}
`;

export const SAVE_STUDY_COHORT = gql`
    mutation saveStudyCohort($studyId: ObjectId!, $cohort: StudyCohortInput!, $reason: String) {
        upsertCohort(studyId: $studyId, cohort: $cohort, reason: $reason) {
            ...StudyCohortFields
        }
    }
    ${StudyCohortFragment}
`;

